import { z } from "zod";

export const auditCategories = ["security", "approvals", "members", "credits", "runs"] as const;
export const auditCategorySchema = z.enum(auditCategories);
export type AuditCategory = z.infer<typeof auditCategorySchema>;

export const auditOutcomes = ["started", "succeeded", "denied", "failed"] as const;
export const auditOutcomeSchema = z.enum(auditOutcomes);
export type AuditOutcome = z.infer<typeof auditOutcomeSchema>;

export const auditEntrySchema = z.object({
  id: z.uuid(),
  projectId: z.uuid(),
  category: auditCategorySchema,
  event: z.string().min(1),
  actorId: z.uuid().nullable(),
  actorName: z.string().nullable(),
  target: z.string().nullable(),
  outcome: auditOutcomeSchema,
  createdAt: z.iso.datetime(),
});
export type AuditEntry = z.infer<typeof auditEntrySchema>;

export const auditFilterSchema = z.enum(["all", ...auditCategories]);
export type AuditFilter = z.infer<typeof auditFilterSchema>;

export const auditQuerySchema = z.object({
  category: auditFilterSchema.optional().default("all"),
  page: z.coerce.number().int().min(1).optional().default(1),
  pageSize: z.coerce.number().int().min(1).max(100).optional().default(20),
});
export type AuditQuery = z.infer<typeof auditQuerySchema>;

export const auditListResponseSchema = z.object({
  entries: z.array(auditEntrySchema),
  page: z.number().int().min(1),
  pageSize: z.number().int().min(1),
  total: z.number().int().min(0),
});
export type AuditListResponse = z.infer<typeof auditListResponseSchema>;
